import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../_helpers/api';

import { Detail } from 'Components/Common/Detail/Detail';
import { Identificacion } from 'Components/Common/Detail/Identificacion';
import { Emisor } from 'Components/Common/Detail/Emisor';
import { Receptor } from 'Components/Common/Detail/Receptor';
import { LoadingPlaceholder } from 'Components/Common/LoadingPlaceholder'

export const DCLEDetail = () => {
  let { codigoGeneracion } = useParams();

  const [dte, setDTE] = useState({});
  const [loading, setLoading] = useState(true);

  const getDetails = () => {
    api.get(`${api.getUri()}DCLE/DTE/${codigoGeneracion}`).then((response) => {
      setDTE(response.data.pop());
      setLoading(false);
    });
  };
  
  const onRefresh = () => {
    getDetails();
  }

  useEffect(() => {
    getDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codigoGeneracion]);

  return (
    <div>
      {loading ? (
        <LoadingPlaceholder />
      ) : (
        <Detail
          loading={loading}
          dte={dte}
          dteType={'DCLE'}
          title={`DTE Documento contable de liquidación electrónica (DCLE): ${loading ? '' : dte.dte.identificacion.codigoGeneracion}`}
          onRefresh={onRefresh}
        >
          <Identificacion
            identificacion={dte.dte.identificacion}
            firma={dte.firma}
            estatus={dte.estatus}
            validationResult={dte.validationResult}
            otherValidationsResult={dte.otherValidationsResult}
          />
          <Emisor emisor={dte.dte.emisor} codigoGeneracion={dte.dte.identificacion.codigoGeneracion} />
          <Receptor receptor={dte.dte.receptor} codigoGeneracion={dte.dte.identificacion.codigoGeneracion} />
          {/* <Resumen resumen={dte.dte.resumen} codigoGeneracion={dte.dte.identificacion.codigoGeneracion} /> */}
        </Detail>
      )}
    </div>
  );
};
